import { ROUTES } from '#/config/routes';

/** 單據管理 hub 導覽卡（單據操作在前；出庫類別主檔置末）。 */
const documentMgmtNavigate = [
  {
    to: ROUTES.stockReceipt,
    title: '入庫管理',
    subtitle: '進貨單列表、建立與審核',
  },
  {
    to: ROUTES.stockTransfer,
    title: '轉倉管理',
    subtitle: '轉倉單列表、建立與審核',
  },
  {
    to: ROUTES.stockIssue,
    title: '出庫管理',
    subtitle: '出庫單列表、建立與審核',
  },
  {
    to: ROUTES.stockAdjustment,
    title: '調整管理',
    subtitle: '調整單列表、建立與審核',
  },
  {
    to: ROUTES.stocktake,
    title: '盤點管理',
    subtitle: '盤點單列表、掃描建立與編輯；全量盤點比對',
  },
  {
    title: '需求管理',
    subtitle: '即將推出',
    disabled: true,
  },
  {
    to: ROUTES.stockIssueCategory,
    title: '出庫類別',
    subtitle: '出庫原因／類別主檔',
  },
];

export default documentMgmtNavigate;
